import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import ListingOrderItemGeneral, { ListingOrderItemStatus } from '../../../models/owner-portal/loi';
import MenuPopover from '../../../components/menu-popover/MenuPopover';
import { PATH_HOME } from '../../../routes/paths';
import Label from '../../../components/label/Label';
import LoiDetails from '../../dashboard/loi/LoiDetails';
import { FDateFormat, fDate } from '../../../utils/formatTime';
import useResponsive from '../../../hooks/useResponsive';
import { fCurrency } from '../../../utils/formatNumber';
import { TableCell, TableRow } from '../../../components/ui/Table';
import { cn } from '../../../lib/utils';

type Props = {
  singleListing: boolean;
  row: ListingOrderItemGeneral;
  selected: boolean;
  onViewRow: VoidFunction;
  onSelectRow: VoidFunction;
  onDeleteRow: VoidFunction;
  dense?: boolean;
  showColumns: Set<keyof ListingOrderItemGeneral>;
};

export function LoiTableRow({
  singleListing,
  row,
  selected,
  onViewRow: _onViewRow,
  onSelectRow: _onSelectRow,
  onDeleteRow: _onDeleteRow,
  dense = true,
  showColumns
}: Props) {
  const {
    title,
    status,
    name_detailed,
    // type_plus_subtype,
    sub_type,
    listing_id,
    last_modified_date_ISO,
    unit_id,
    amount,
    discount,
    total_amount,
    end_date_ISO
  } = row;

  const denseHeight = dense ? 52 : 72;

  const isDesktop = useResponsive('up', 'md');
  const isMobile = useResponsive('down', 'sm');
  // const dateFormat = useMemo(() => {
  //     if (isDesktop) {
  //         return FDateFormat.localized_date_time_full
  //     }
  //     return FDateFormat.localized_us_numeric_month_day_year
  // }, [isDesktop])

  const [openPopover, setOpenPopover] = useState<HTMLElement | null>(null);

  const handleOpenPopover = (event: React.MouseEvent<HTMLElement>) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  return (
    <>
      <TableRow
        onClick={handleOpenPopover}
        className={cn('cursor-pointer', selected && 'bg-muted')}
        style={{ height: denseHeight }}
      >
        {!singleListing && showColumns.has('name_detailed') && (
          <TableCell>
            <NavLink
              to={PATH_HOME.property.view(listing_id)}
              className="text-sm font-medium text-primary dark:text-secondary hover:underline"
            >
              {isDesktop ? name_detailed : unit_id}
            </NavLink>
          </TableCell>
        )}
        {showColumns.has('title') && isMobile && (
          <TableCell className="max-w-[75px] whitespace-nowrap overflow-hidden text-ellipsis">
            {title}
          </TableCell>
        )}
        {showColumns.has('title') && !isMobile && <TableCell>{title}</TableCell>}
        {showColumns.has('amount') && (
          <TableCell>
            {discount > 0 && (
              <div className="flex flex-col">
                <div className="flex flex-row">
                  <span className="text-xs text-muted-foreground line-through">
                    {fCurrency(amount, true)}
                  </span>
                </div>
                <span className="text-sm">{fCurrency(total_amount, true)}</span>
              </div>
            )}
            {!discount && <span className="text-sm">{fCurrency(total_amount, true)}</span>}
          </TableCell>
        )}
        {showColumns.has('status') && (
          <TableCell>
            <Label
              variant="soft"
              color={
                (status === ListingOrderItemStatus.approved && 'primary') ||
                (status === ListingOrderItemStatus.close && 'warning') ||
                'info'
              }
            >
              {status}
            </Label>
          </TableCell>
        )}
        {showColumns.has('sub_type') && <TableCell>{sub_type}</TableCell>}
        {showColumns.has('last_modified_date_ISO') && (
          <TableCell>
            {fDate(last_modified_date_ISO, FDateFormat.localized_us_numeric_month_day_year)}
          </TableCell>
        )}
        {showColumns.has('end_date_ISO') && (
          <TableCell className="text-right">
            {fDate(end_date_ISO, FDateFormat.localized_us_numeric_month_day_year)}
          </TableCell>
        )}
        {/* <TableCell align="right">
                    <IconButton color={openPopover ? 'inherit' : 'default'} onClick={handleOpenPopover}>
                        <Iconify icon="eva:more-vertical-fill" />
                    </IconButton>
                </TableCell> */}
      </TableRow>
      <MenuPopover open={openPopover} onClose={handleClosePopover} arrow="right-center">
        <LoiDetails loi={row} />
      </MenuPopover>
    </>
  );
}
